import CompactContentContainerStyles from './types';

const compactContentContainerStyles: CompactContentContainerStyles = (styles) => styles.alignItemsBaseline;

export {
    // eslint-disable-next-line import/prefer-default-export
    compactContentContainerStyles,
};
